import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from "lucide-react";
interface CapabilityStatusTileProps {
  label: string;
  icon: LucideIcon;
  className?: string;
  flip?: boolean;
}
const CapabilityStatusTile = t0 => {
  const $ = _c(10);
  const {
    label,
    icon: Icon,
    className: t1,
    flip: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const flip = t2 === undefined ? false : t2;
  const t3 = `flex items-center gap-2.5 rounded-xl border border-black/5 bg-white px-2.5 py-2 shadow-sm ${flip ? "flex-row-reverse" : ""} ${className}`;
  let t4;
  if ($[0] !== Icon) {
    t4 = <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-card-foreground text-white"><Icon size={15} /></span>;
    $[0] = Icon;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `min-w-0 flex-1 truncate text-sm font-bold text-neutral-800 ${flip ? "text-right" : ""}`;
  let t6;
  if ($[2] !== label || $[3] !== t5) {
    t6 = <span className={t5}>{label}</span>;
    $[2] = label;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="relative flex size-1.5 shrink-0"><span className="absolute inline-flex size-full animate-ping rounded-full bg-card-foreground/40" /><span className="relative inline-flex size-1.5 rounded-full bg-card-foreground" /></span>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t6) {
    t8 = <div className={t3}>{t4}{t6}{t7}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};
export default CapabilityStatusTile;